module.exports = __webpack_public_path__ + "static/media/calidad.41a9a207.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/calidad.svg
// module id = 193
// module chunks = 0